export { McpPage } from "./ui/mcp-page"
